import './AboutUsComponent.scss';
export default function AboutUsComponent() {
    return (
        <section className='tw-px-4 md:tw-px-16 about-us'>
            <div id='about-us' class="">
                <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-1 tw-gap-4">
                    
                    <div class="tw-col-span-1 md:tw-col-span-1">
                        <h3 className='tw-flex tw-justify-center tw-uppercase section-header'>
                            Who we are
                        </h3>
                        <div className='tw-text-center md:tw-text-justify tw-py-8 md:tw-px-16 tw-py-4 md:tw-py-16'>
                            Founded in 2022, Kakariki Coffee was born from a deep love for hospitality and the joy of bringing people together over great food and coffee. With strong roots in the restaurant industry, the inspiration behind Kakariki Coffee has always been about more than just serving coffee—it’s about creating a space where people feel cared for, welcomed, and at home.
                            <br />
                            <br />
                            In a short time, Kakariki Coffee has quickly become a favourite among Wellington’s business and ministry communities, drawing a steady stream of regulars for their morning coffee and lunch. The café was recently featured in The Post, where it was praised for its welcoming vibe, plant-filled interior, and the passionate team that makes every visit special. Serving freshly roasted Mojo beans brewed to perfection, Kakariki Coffee is more than just a café—it’s a place of warmth, connection, and community.
                            <br />
                            <br />
                            <div className='tw-text-center'>
                                ☕ <b className='tw-text-center'>With every cup poured, they bring a little more warmth, a little more green, and a whole lot of love to Wellington’s coffee scene</b> 🌿
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}